import React, { memo } from 'react';
import cn from 'clsx';
import { KitchenCollection } from 'modules/collections';
import { createElementKey } from 'utils';
import { ProductSchema } from '../product-schema';
import { CatalogCard } from './components';
import { catalogGrid } from './gallery-catalog-styles';

type GalleryCatalogProps = {
  cardRefCb?: (el: HTMLAnchorElement | null) => void;
  catalog: KitchenCollection[];
  children?: React.ReactNode;
  className?: string;
  downloadCatalog?: React.ReactNode;
  onCardClick: (collection: KitchenCollection, position: number) => void;
  onCollectionPreviewClick?: (collection: KitchenCollection) => void;
  renderCardContent: (collection: KitchenCollection) => React.ReactNode;
};

export const GalleryCatalog: React.FC<GalleryCatalogProps> = memo(
  ({ catalog, cardRefCb, children, className, downloadCatalog, onCardClick, onCollectionPreviewClick, renderCardContent }) => {
      return (
      <>
        <ul
          data-testid="gallery-catalog"
          className={cn(catalogGrid, className)}>
          {catalog.map((collection, index: number) => (
            <li key={createElementKey('collection', index)}>
              <CatalogCard
                position={index}
                cardRefCb={cardRefCb}
                collection={collection}
                onCardClick={onCardClick}
                onCollectionPreviewClick={onCollectionPreviewClick}
                renderCardContent={renderCardContent}
              />
            </li>
          ))}
          {downloadCatalog}
          {children}
        </ul >

        <ProductSchema />
      </>
    );
  }
);
